import { Link } from "react-router-dom";
import { Button, LangPicker, Logo } from "@b00k/ui";
import { useT } from "../i18n/index.js";
import { wartoscKonfiguracji } from "../lib/config.js";
import type { Lang } from "@b00k/domain";

const OPERATOR_URL = wartoscKonfiguracji("operatorUrl", import.meta.env.VITE_OPERATOR_URL, "http://localhost:5274");

export function SiteHeader({ lang, onLang }: { lang: Lang; onLang: (l: Lang) => void }) {
  const t = useT();
  return (
    <header className="ld-header">
      <div className="ld-header__inner">
        <Link className="ld-brand" to="/">
          <Logo />
          <span>
            b<em>00</em>k<small>.online</small>
          </span>
        </Link>
        <nav className="ld-nav">
          <a href="/#kategorie">{t.navCats}</a>
          <a href="/#jak">{t.navHow}</a>
          <a href="/#operatorzy">{t.navOps}</a>
          <a href="/#cennik">{t.navPrice}</a>
          <a href="/#kontakt">{t.navContact}</a>
        </nav>
        <LangPicker value={lang} onChange={onLang} />
        {/* Makieta prowadzi z nagłówka do demo panelu operatora; rejestracja ma CTA w hero. */}
        <a href={OPERATOR_URL} className="ld-header__cta">
          <Button size="sm">{t.navBook}</Button>
        </a>
      </div>
    </header>
  );
}
